export default class accountRequest {
  constructor(service) {
    this.service = service;
  }

  login$(username, password) {
    return this.service
      .fetch$({
        method: 'POST',
        url: '/account/login/',
        body: {
          username,
          password,
        },
      });
  }

  createAccount$(username, password, displayName) {
    return this.service
      .fetch$({
        method: 'POST',
        url: '/account/',
        body: {
          username,
          password,
          displayName,
        },
      });
  }

  getListAccount$() {
    return this.service
      .fetch$({
        method: 'GET',
        url: '/account/all',
        body: {
        },
      });
  }

  update$(id, data) {
    return this.service
      .fetch$({
        method: 'PUT',
        url: `/account/${id}`,
        body: {
          ...data,
        },
      });
  }
}
